<form>
	<div class="login-body">
		<div class="login-wrapper">
			<div class="login-panel">
				<img
					src="https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/Focus-With-Cloud-New-Trans.png"
					style="width: 300px; height: auto"
					class="logo"
					alt="Focus POS Systems Logo"
				/>

				<div class="login-form" style="width: 100%">
					<input pInputText type="email" name="email" id="email" placeholder="Email" required [(ngModel)]="user.email" />
					<input
						*ngIf="!forgotPassword"
						pInputText
						type="password"
						name="password"
						id="password"
						placeholder="Password"
						required
						[(ngModel)]="user.password"
					/>
					<button
						*ngIf="!forgotPassword"
						[disabled]="maintenanceCycle"
						pButton
						pRipple
						class="m-2"
						label="Log In"
						type="button"
						type="submit"
						(click)="login()"
					></button>
					<button
						*ngIf="forgotPassword"
						[disabled]="maintenanceCycle"
						pButton
						pRipple
						class="m-2"
						label="Reset Password"
						type="button"
						type="submit"
						(click)="resetPasswordRequest()"
					></button>
					<span *ngIf="errorCondition" style="color: red">{{ errorCondition }}</span>
					<p *ngIf="!forgotPassword" (click)="forgotPassword = true">Forgot your password?</p>
				</div>

				<div>
					<p>A problem? <a href="https://www.focuspos.com/contact-us/" target="_blank">Click here</a> and let us help you.</p>
					<div class="d-flex justify-content-center">
						<app-terms-of-service-footer></app-terms-of-service-footer>
					</div>
				</div>
			</div>
			<div class="login-image">
				<div class="login-image-content">
					<img
						src="https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/commandCenterBanner.png"
						alt="FocusOnline Commmand Center Banner"
					/>
				</div>
				<div class="image-footer">
					<p>&#169; {{ moment().format("Y") }} Focus POS Systems, Inc</p>
					<div class="icons">
						<i class="pi pi-facebook" (click)="goTo('https://facebook.com/focuspos')"></i>
						<i class="pi pi-twitter" (click)="goTo('https://twitter.com/focuspos')"></i>
					</div>
				</div>
			</div>
		</div>
	</div>
</form>

<p-dialog [(visible)]="maintenanceCycle" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [style]="{ width: '50vw' }">
	<img src="https://focuspos-onlineorder-images.s3.us-west-2.amazonaws.com/commandCenterAdBanner.png" width="100%" height="auto" />
	<div class="d-flex flex-column">
		<div class="h3 text-center text-capitalize">Maintenance in process</div>
		<div class="text-center mt-4">CommandCenter is currently undergoing maintenance</div>
		<div class="text-center mt-1">service will be restored at approximately 8:30PM CST/7:30PM MST.</div>
		<div class="text-center mt-1">All ordering functions will be fully operable and POS services will not be effected.</div>
	</div>
</p-dialog>
